module.exports = __webpack_public_path__ + "img/ade4dd4.jpg";